import Auth from "@optimusride/client-library/auth";
import APIs from "@optimusride/client-library/api";
import { APPLICATION_NAME, GRPC_URL } from "@optimusride/client-library/constants";

export const auth = new Auth(APPLICATION_NAME.COMMANDOR, GRPC_URL);
export const apis = APIs(auth, GRPC_URL);
